module.exports = __webpack_public_path__ + "static/media/3dvista.52c39b06.png";